/*
 * Auth API — dispatches to the localStorage mock or the real HTTP backend based
 * on USE_MOCK_API. The export name `signInWithGoogleMock` is kept for call-site
 * stability; in HTTP mode it performs a real /auth/google exchange.
 */
import { USE_MOCK_API } from './httpClient'
import * as mock from './auth.mock'
import * as http from './auth.http'

const impl = USE_MOCK_API ? mock : http

export const signInWithGoogleMock = impl.signInWithGoogleMock
export const getSession = impl.getSession
export const signOut = impl.signOut
export const patchMe = impl.patchMe
